import { MutationOptions, useMutation } from 'react-query';

import { useWorkspaceId } from '@app/hooks/useWorkspaceId';
import BlobFile from '@app/store/documents/BlobFile';
import SampleFile from '@app/store/documents/SampleFile';
import UploadFile from '@app/store/documents/UploadFile';
import { postEditingDocuments } from '@app/store/transport-layer/document/editing-documents';
import { documentUpload } from '@app/store/transport-layer/upload/document/upload';

interface UploadDocumentFileReturnType {
  editingDocumentId: string;
  fileId: string;
  isThirdParty: boolean;
  title: string;
  url: string;
}

type UploadDocumentFile = File | UploadFile | SampleFile | BlobFile;

export default function useUploadEditingDocumentFile(
  options?: MutationOptions<UploadDocumentFileReturnType, Error, UploadDocumentFile>
) {
  const workspaceId = useWorkspaceId();

  return useMutation<UploadDocumentFileReturnType, Error, UploadDocumentFile>(
    async (file: UploadDocumentFile) => {
      // 문서 파일 업로드
      const { isThirdParty, fileId, title, url } = await documentUpload(file);
      const { editingDocumentId } = await postEditingDocuments(workspaceId, {
        fileId,
        name: title,
      });

      return {
        editingDocumentId,
        fileId,
        isThirdParty,
        title,
        url,
      };
    },
    options
  );
}
